import { Component, inject, Inject, OnInit } from '@angular/core';
import { Qualification } from '../../data/qualification';
import { ILookup } from '../../data/Ilookup';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { IKeyValue } from '../../data/Ikey-value';
import { LookupDataService } from '../../services/lookup-data.service';
import { LookupItem, LookupValueMapper } from '../../models/lookup-item';
import { ApplicantText } from '../../models/applicant-text';
import { NonNullableFormBuilder, Validators } from '@angular/forms';


@Component({
  selector: 'app-qualification-dialog',
  templateUrl: './qualification-dialog.component.html',
  styleUrl: './qualification-dialog.component.scss'
})
export class QualificationDialogComponent implements OnInit {

  qualification: Qualification;
  qualificationLevels: LookupItem[];
  countries: LookupItem[];
  applicantText: ApplicantText;

 formBuilder = inject(NonNullableFormBuilder);

  qualificationForm = this.formBuilder.group({
      type: [null as LookupItem | null, [Validators.required]],
      course: ['', [Validators.required]],
      institution: [''],
      country: [null as LookupItem | null],
      postcode: [''],
      start: [''],
      end: ['']

  });


  constructor(
    public dialogRef: MatDialogRef<QualificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      qualification: Qualification;
      qualificationLevels: LookupItem[];
      countries: LookupItem[];
      applicantText: ApplicantText;

    }
  ) {
    this.qualification = data.qualification || new Qualification();
    this.qualificationLevels = data.qualificationLevels || [];
    this.applicantText = data.applicantText;
    this.countries = data.countries || [];
  }


  ngOnInit(): void {
      this.qualificationForm.patchValue({
        ...this.qualification,
      country: LookupValueMapper.toLookupItem(this.qualification.country)
      });
      
      this.qualificationForm.valueChanges.subscribe(value => {
        this.qualification = { 
          ...this.qualification, 
          ...value, 
          country: LookupValueMapper.toLookupValue(value.country) 
        };
      });
  }

  trackByQualificationId(index: number, item: ILookup): any {
    return item.id;
  }

  close(): void {
    
    if(this.qualificationForm.valid) {  
      this.dialogRef.close(this.qualification);
    }
    else{
      this.qualificationForm.markAllAsTouched();
    }
    
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
